import panel from './panel';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [panel],
  urlMap: {}
};

// Initialize urlMap：递归收集所有带 url 的菜单项，按 url 建索引。
// 递归是为了兼容 collapse 分组的多层嵌套（如「运维 → 动态DNS」）；
// 分组节点自身没有 url，跳过以免写入 undefined 键。
const collectByUrl = (nodes, map) => {
  (nodes || []).forEach((node) => {
    if (node.url) {
      map[node.url] = node;
    }
    if (node.children?.length) {
      collectByUrl(node.children, map);
    }
  });
  return map;
};

menuItems.urlMap = collectByUrl(menuItems.items, {});

export default menuItems;
